import Issuer from '@/creditflowresearch/ui/components/issuer';
import getServerSideResearchData from '@/creditflowresearch/application/Research/serverSide/getServerSideResearchData';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import { getServerSideBondsTileData,
} from '@/creditflowresearch/application/Bonds/serverSide/getServerSideBondsTileData';
import {
  getServerSideTraceTileData,
} from '@/creditflowresearch/application/Trace/serverSide/getServerSideTraceTileData';
import getServerSideIssuerBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideIssuerBreadcrumbs';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import * as FILTER_TYPES from '@/creditflowresearch/application/PageFiltersState/constants';
import withCompanyByIdlProps from '@/creditflowresearch/application/Company/withCompanyByIdlProps';
import pageNotFound from '@/dmPortal/ui/common/PageNotFound';
import getServerSideArticlesTile
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';
import { Product } from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import getQueryParamsWithProductsRegions from '@/creditflowresearch/application/helpers/getQueryParamsWithProductsRegions';
import { pageRedirectTo } from '@framework/router/Next/helpers';
import { getProducts } from '@/creditflowresearch/application/Deal/helpers';
import getServerSideDealsByProduct from '@/creditflowresearch/application/Deal/helpers/utils/getServerSideDealsByProduct';
import getServerSideRoadshows from '@/creditflowresearch/application/Roadshows/serverSide/getServerSideRoadshows';

export const getServerSideProps = withCompanyByIdlProps(async (context) => {
  if (!context?.company.id) {
    return pageNotFound();
  }
  const { availableProductIds, activeProductId } = getProducts(context);

  const products = context.userPlanState.products.map(
    (productId) => Product.getAbbreviation(productId),
  ).filter(Boolean) as string[];
  const regions = context.userPlanState.regions.map(
    (regionId) => Region.getAbbreviation(regionId),
  ).filter(Boolean) as string[];
  const queryParams = getQueryParamsWithProductsRegions(
    context.query,
    ['companyViewId', 'issuerName'],
    { products, regions },
  );

  if (queryParams) {
    return pageRedirectTo(`${ context.resolvedUrl }${ queryParams }`);
  }

  const [
    deals,
    researchData,
    { breadcrumbs, parent },
    bondTileData,
    traceTileData,
    articlesTilesData,
    roadshowsTileData,
  ] = await Promise.all([
    getServerSideDealsByProduct(context, {
      includedCompanyRole: FILTER_TYPES.ISSUER,
      additionalFilters: {
        includedIssuerIds: [context?.company?.id],
      },
    }),
    getServerSideResearchData(context, { isTile: true }),
    getServerSideIssuerBreadcrumbs(context, { products, regions }),
    getServerSideBondsTileData(context),
    getServerSideTraceTileData(context),
    getServerSideArticlesTile(context, { deal: null }),
    getServerSideRoadshows(context, { isTile: true }),
  ]);

  return ({
    props: {
      company: context?.company,
      breadcrumbs,
      parent,
      researchData,
      deals,
      bondTileData,
      traceTileData,
      articlesTilesData,
      availableProductIds,
      activeProductId,
      roadshowsTileData,
    },
  });
});

const IssuerName = (props) => (
  <PageFiltersContextProvider company={ props?.company }>
    <ParentPageContextProvider parentProps={ {
      parent: props?.parent,
      deals: props?.deals,
      research: props?.researchData,
      traceTileData: props?.traceTileData,
      bondTileData: props?.bondTileData,
      articlesTilesData: props?.articlesTilesData,
      availableProductIds: props?.availableProductIds,
      activeProductId: props?.activeProductId,
      roadshowsTileData: props?.roadshowsTileData,
    } }
    >
      <PageContentLayout>
        <Issuer />
      </PageContentLayout>
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default IssuerName;
